<template>
  <Modal :open="isOpen" :close="handleClose">
    <div class="px-10 py-5">
      <h2 class="font-black text-gray-500 pr-32 mb-2">
        Are you sure you want to sync?
      </h2>
      <div class="mt-10 flex justify-center">
        <button
          @click="handleSync()"
          type="submit"
          class="mr-5 inline-flex items-center px-4 py-2 border border-grey-300 rounded-md shadow-sm text-xs font-medium text-grey-700 bg-white hover:bg-grey-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
        >
          Yes
          <IconSync
            class="ml-1 animate-spin text-green"
            v-if="isSyncing === 1"
          />
          <IconSolidCheck v-if="isSyncing === 2" />
        </button>
        <button
          @click="handleClose"
          type="button"
          class="mr-2 inline-flex items-center px-4 py-2 border border-grey-300 rounded-md shadow-sm text-xs font-medium text-grey-700 bg-white hover:bg-grey-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
        >
          No
        </button>
      </div>
    </div>
  </Modal>
</template>

<script>
import Modal from "@/components/Shared/Modal/Base";
import IconSolidCheck from "@/assets/icons/IconSolidCheck";
import IconSync from "@/assets/icons/IconSync";

export default {
  name: "STLSyncConfirmation",
  components: {
    Modal,
    IconSolidCheck,
    IconSync
  },
  props: {
    handleClose: {
      type: Function,
      required: true
    },
    isOpen: {
      type: Boolean,
      required: true
    },
    isSyncing: {
      type: Number,
      required: true
    },
    handleSync: {
      type: Function,
      required: true
    }
  }
};
</script>
